module.exports = __webpack_public_path__ + "assets/back.40c355258a89cdc8d2e5da36a6598075.png";